import { BrandLeaderboard } from '../components/BrandLeaderboard';
import { BrandAdmin } from './shared/BrandAdmin';

export function BrandsPage() {
  return (
    <div className="space-y-5">
      <BrandLeaderboard limit={50} title="Brand leaderboard" />
      <BrandAdmin />
    </div>
  );
}
